module.exports = __webpack_public_path__ + "static/media/logo-헤븐트리@3x.5f16b52c.png";